import axios from 'axios';
import { CatalogHierarchyApi } from '../../../shared/service/catalogHierarchyApi';

export const EquipmentApi = {
  // Seleção hierárquica: Categoria → Produto → Serviço
  getCategorias: () => CatalogHierarchyApi.getCategorias(),
  getProdutosByCategoria: (categoriaId) => CatalogHierarchyApi.getProdutosByCategoria(categoriaId),
  getServicosByProduto: (produtoId) => CatalogHierarchyApi.getServicosByProduto(produtoId),

  // TODO: INEXISTENTE no backend: /web/equipments/{id}
  getById: (id) => axios.get(`/web/equipments/${id}`),

  // TODO: INEXISTENTE no backend: /web/equipments
  create: (data) => axios.post('/web/equipments', data),

  // TODO: INEXISTENTE no backend: /web/equipments/{id}
  update: (id, data) => axios.put(`/web/equipments/${id}`, data),

  // TODO: INEXISTENTE no backend: /web/equipments/photos
  uploadPhoto: (formData) =>
    axios.post('/web/equipments/photos', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  // TODO: INEXISTENTE no backend: /web/equipments/photos/{id}
  deletePhoto: (id) => axios.delete(`/web/equipments/photos/${id}`),

  // TODO: INEXISTENTE no backend: /web/equipments/laudos
  uploadLaudo: (formData) =>
    axios.post('/web/equipments/laudos', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  // TODO: INEXISTENTE no backend: /web/equipments/laudos/{id}
  deleteLaudo: (id) => axios.delete(`/web/equipments/laudos/${id}`)
};
